import cookie from 'vue-cookie'

const TERRAINDEX_DOMAIN = '@terraindex.com'

// Customer accounts that may use the internal-only (`terraIndexOnly`) import/export formats.
const IMPORT_EXPORT_USERNAMES = ['veenstra@pjmilieu.nl', 'sjoerd.hoekstra@tauw.com']

function normalize(username) {
  return String(username || '').trim().toLowerCase()
}

function isTerraIndexUser(username = cookie.get('username')) {
  return normalize(username).endsWith(TERRAINDEX_DOMAIN)
}

// TerraIndex users always pass; other accounts only on an exact (case-insensitive) username match.
function isTerraIndexOrAllowedUser(allowedUsernames = [], username = cookie.get('username')) {
  if (isTerraIndexUser(username)) return true

  const current = normalize(username)
  return !!current && allowedUsernames.some(allowed => normalize(allowed) === current)
}

// An item can name its own `allowedUsernames`; otherwise the generic import/export accounts apply.
function isVisibleToUser(item, username) {
  return !item.terraIndexOnly || isTerraIndexOrAllowedUser(item.allowedUsernames || IMPORT_EXPORT_USERNAMES, username)
}

export default {
  isTerraIndexUser,
  isTerraIndexOrAllowedUser,
  isVisibleToUser
}
